import React, {Fragment, useEffect, useState} from 'react'
import { requestAPI } from '../../data/api'
import imageProperties from './imageProperties.json'
import MappingInput from './MappingInput'

export default function MetadataMappings(props) {
	const { clientId } = props
	const [ mappings, setMappings ] = useState([])

	useEffect(()=>{
		(async function getMappings(){
			const storedMappings = await requestAPI(`/metadata-mappings/?clientId=${clientId}`, 'GET')
			setMappings(storedMappings)
		})()
	},[])

	const getMapping = imageProperty => {
		const exisitingMapping = mappings.find(mapping => 
			mapping.image_property === imageProperty,
		)
		return exisitingMapping ? exisitingMapping.metadata_field : ''
	}

	return <Fragment>
		<h3 className='section'>Metadata mappings</h3>
		{imageProperties.map(property => {
			return <Fragment key={property.value}>
				<p>{property.name}</p>
				<MappingInput 
					clientId={clientId}
					metadataField={getMapping(property.value)}
					imageProperty={property.value}
				/>
			</Fragment>
		})}
	</Fragment>
}
